import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '../../useAddress'

const CookingEnergy = () => {
  const { t, updateAddress, cookingEnergy, cookingOptions, errors } = useAddress()
  const error = getError('cookingMode', errors)

  return (
    <SDFormControl plainLabel error={error}>
      <SDSelect
        label={t('subscriptionTools:estimator.cooking_mode.label')}
        optionsList={cookingOptions}
        translationsPath='subscriptionForm:address_module.cooking_types.'
        newTranslations={true}
        onChangeHandler={params => updateAddress({ cookingEnergy: params.option?.id })}
        selectedValue={cookingEnergy ? cookingEnergy.toString() : ''}
        hasError={!!error}
      />
    </SDFormControl>
  )
}
export default CookingEnergy
